module.exports = __webpack_public_path__ + "static/media/info_square_o.b6bd9058.svg";